import { useExplorerConfig } from './providers'
import { SText, SView, SViewProps } from './scaled'

interface Props extends SViewProps {}

export default function WelcomeUser(props: Props) {
  const { facility } = useExplorerConfig()

  return (
    <SView gap={6} maxW={250} {...props}>
      <SText fontSize={25}>Welcome</SText>

      <SText lineClamp={2} fontSize={30} lineHeight={1} fontWeight="bold">
        {facility?.companyName}
      </SText>
    </SView>
  )
}
